import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import QualityCheckActions, { qualityCheckActionTypes } from '@Actions/quality/qualityCheckActions';
import QualityCheckServices from '../../services/quality/qualityCheckServices';

function* _createQualityCheck(action) {
  try {
    yield put(QualityCheckActions.createQualityCheckLoading(true));
    const qualityCheck = yield QualityCheckServices.createQualityCheck(action.payload);
    if (qualityCheck.success) {
      yield put(TrackerActions.trackAction(qualityCheckActionTypes.CREATE_QUALITY_CHECK.SUCCESS, qualityCheck));
      notification.open({
        type: 'success',
        message: 'Quality Check successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(qualityCheck);
      yield put(QualityCheckActions.createQualityCheckLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: qualityCheck?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(QualityCheckActions.createQualityCheckLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(QualityCheckActions.createQualityCheckLoading(false));
    yield put(TrackerActions.trackAction(qualityCheckActionTypes.CREATE_QUALITY_CHECK.ERROR, error));
  }
}

function* createQualityCheck() {
  yield takeLatest(qualityCheckActionTypes.CREATE_QUALITY_CHECK.REQUEST, _createQualityCheck);
}

function* _updateQualityCheck(action) {
  try {
    yield put(QualityCheckActions.updateQualityCheckLoading(true));
    const qualityCheck = yield QualityCheckServices.updateQualityCheck(action.payload);
    if (qualityCheck.success) {
      yield put(TrackerActions.trackAction(qualityCheckActionTypes.UPDATE_QUALITY_CHECK.SUCCESS, qualityCheck.data));
      notification.open({
        type: 'success',
        message: 'Quality Check successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback(qualityCheck);
      yield put(QualityCheckActions.updateQualityCheckLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: qualityCheck?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(QualityCheckActions.updateQualityCheckLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(QualityCheckActions.updateQualityCheckLoading(false));
    yield put(TrackerActions.trackAction(qualityCheckActionTypes.UPDATE_QUALITY_CHECK.ERROR, error));
  }
}

function* updateQualityCheck() {
  yield takeLatest(qualityCheckActionTypes.UPDATE_QUALITY_CHECK.REQUEST, _updateQualityCheck);
}

function* _getQualityChecks(action) {
  try {
    QualityCheckActions.getQualityChecksSuccess(null);
    yield put(QualityCheckActions.getQualityChecksLoading(true));
    const {
      tenantId, entityId, entityName, status, qcType, page, limit, searchKeyword, startDate, endDate, batchId, defaultAssigneeId
    } = action;
    const qualityChecks = yield QualityCheckServices.getQualityChecks(tenantId, entityId, entityName, status, qcType, page, limit, searchKeyword, startDate, endDate, batchId, defaultAssigneeId);
    yield put(QualityCheckActions.getQualityChecksSuccess(qualityChecks));
    yield put(QualityCheckActions.getQualityChecksLoading(false));
  } catch (error) {
    yield put(QualityCheckActions.getQualityChecksLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(qualityCheckActionTypes.GET_QUALITY_CHECKS.ERROR, error));
  }
}

function* getQualityChecks() {
  yield takeLatest(qualityCheckActionTypes.GET_QUALITY_CHECKS.REQUEST, _getQualityChecks);
}

function* _getQualityCheckById(action) {
  try {
    yield put(QualityCheckActions.getQualityCheckByIdLoading(true));
    const {
      tenantId, qcId,
    } = action;
    const selectedQualityCheck = yield QualityCheckServices.getQualityCheck(tenantId, qcId);
    yield put(QualityCheckActions.getQualityCheckByIdSuccess(selectedQualityCheck?.data?.sales_orders[0] || {}));
    yield put(QualityCheckActions.getQualityCheckByIdLoading(false));
  } catch (error) {
    yield put(QualityCheckActions.getQualityCheckByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(qualityCheckActionTypes.GET_QUALITY_CHECK_BY_ID.ERROR, error));
  }
}

function* getQualityCheckById() {
  yield takeLatest(qualityCheckActionTypes.GET_QUALITY_CHECK_BY_ID.REQUEST, _getQualityCheckById);
}

function* _getDownloadQualityChecks(action) {
  const {
    tenantId, qualityCheckId, entityName, entityId, userId
  } = action;
  try {
    yield put(QualityCheckActions.getDownloadQualityChecksLoading(true));
    notification.open({
      type: 'warning',
      message: 'Please wait while the quality inspection sheet is being prepared.',
      duration: 4,
      placement: 'top',
    });
    const qcDownload = yield QualityCheckServices.getDownloadQualityChecks(tenantId, qualityCheckId, entityName, entityId, userId);
    if (!qcDownload) {
      notification.open({
        type: 'error',
        message: qcDownload.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(QualityCheckActions.getDownloadQualityChecksLoading(false));
      const link = document.createElement('a');
      link.target = '_blank';
      link.download = 'QualityCheckRule';
      link.href = URL.createObjectURL(
        new Blob([qcDownload], { type: qcDownload.type }),
      );
      link.click();
      yield put(QualityCheckActions.getDownloadQualityChecksLoading(false));
    }
  } catch (error) {
    yield put(QualityCheckActions.getDownloadQualityChecksLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(qualityCheckActionTypes.GET_DOWNLOAD_QUALITY_CHECK.ERROR, error));
  }
}

function* getDownloadQualityChecks() {
  yield takeLatest(qualityCheckActionTypes.GET_DOWNLOAD_QUALITY_CHECK.REQUEST, _getDownloadQualityChecks);
}

function* _deleteQualityCheck(action) {
  try {
    yield put(QualityCheckActions.deleteQualityCheckLoading(true));
    const qualityCheck = yield QualityCheckServices.deleteQualityCheck(action.payload);

    if (qualityCheck.success) {
      notification.open({
        type: 'success',
        message: 'Quality Check successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: qualityCheck?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(QualityCheckActions.deleteQualityCheckLoading(false));
  } catch (error) {
    yield put(QualityCheckActions.deleteQualityCheckLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(qualityCheckActionTypes.DELETE_QUALITY_CHECK.ERROR, error));
  }
}

function* deleteQualityCheck() {
  yield takeLatest(qualityCheckActionTypes.DELETE_QUALITY_CHECK.REQUEST, _deleteQualityCheck);
}
// get quality check report
function* _getQualityCheckReport(action) {
  try {
    yield put(QualityCheckActions.getQualityCheckReportLoading(true));
    const { tenantId, entityName, status, qcType, startDate, endDate, operationType, userId } = action;
    const response = yield QualityCheckServices.getQualityCheckReport(tenantId, entityName, status, qcType, startDate, endDate, operationType, userId);
    if (response.success) {
      notification.open({
        type: 'success',
        message: "We are processing your request. You will receive the data on your email.",
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: response.message,
        duration: 4,
        placement: 'top',
      });
    }
    action.callback();
    yield put(QualityCheckActions.getQualityCheckReportLoading(false));
  } catch (error) {
    yield put(QualityCheckActions.getQualityCheckReportLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(qualityCheckActionTypes.GET_QUALITY_CHECK_REPORT.ERROR, error));
  }
}

function* getQualityCheckReport() {
  yield takeLatest(qualityCheckActionTypes.GET_QUALITY_CHECK_REPORT.REQUEST, _getQualityCheckReport);
}

// Qc retest
function* _retestQualityCheck(action) {
  try {
    yield put(QualityCheckActions.retestQualityCheckLoading(true));
    yield put(action.payload.loadingHandler(true));
    const response = yield QualityCheckServices.retestQualityCheck(action.payload);
    if (response.success) {
      notification.open({
        type: 'success',
        message: response.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: response.message,
        duration: 4,
        placement: 'top',
      });
    }
    action.callback();
    yield put(QualityCheckActions.retestQualityCheckLoading(false));
    yield put(action.payload.loadingHandler(false));
  } catch (error) {
    yield put(QualityCheckActions.retestQualityCheckLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,

    });
    yield put(TrackerActions.trackAction(qualityCheckActionTypes.RETEST_QUALITY_CHECK.ERROR, error));
  }
}

function* retestQualityCheck() {
  yield takeLatest(qualityCheckActionTypes.RETEST_QUALITY_CHECK.REQUEST, _retestQualityCheck);
}

// Qc on Hold
function* _putQualityCheckOnHold(action) {
  try {
    yield put(QualityCheckActions.putQualityCheckOnHoldLoading(true));
    const response = yield QualityCheckServices.putQualityCheckOnHold(action.payload);
    if (response.success) {
      notification.open({
        type: 'success',
        message: response.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: response.message,
        duration: 4,
        placement: 'top',
      });
    }
    action.callback();
    yield put(QualityCheckActions.putQualityCheckOnHoldLoading(false));
  } catch (error) {
    yield put(QualityCheckActions.putQualityCheckOnHoldLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,

    });
    yield put(TrackerActions.trackAction(qualityCheckActionTypes.PUT_QC_ON_HOLD.ERROR, error));
  }
}

function* putQualityCheckOnHold() {
  yield takeLatest(qualityCheckActionTypes.PUT_QC_ON_HOLD.REQUEST, _putQualityCheckOnHold);
}

function* _updateQualityCheckAssignees(action) {
  try {
    yield put(QualityCheckActions.updateQualityCheckAssigneesLoading(true));
    const qualityCheck = yield QualityCheckServices.updateQualityCheckAssignees(action.payload);

    if (qualityCheck.success) {
      notification.open({
        type: 'success',
        message: 'Quality Check Assignees successfully update',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: qualityCheck?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(QualityCheckActions.updateQualityCheckAssigneesLoading(false));
  } catch (error) {
    yield put(QualityCheckActions.updateQualityCheckAssigneesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(qualityCheckActionTypes.UPDATE_QC_ASSIGNEES.ERROR, error));
  }
}

function* updateQualityCheckAssignees() {
  yield takeLatest(qualityCheckActionTypes.UPDATE_QC_ASSIGNEES.REQUEST, _updateQualityCheckAssignees);
}

export default function* qualityCheckSaga() {
  yield all([
    createQualityCheck(),
    updateQualityCheck(),
    getQualityChecks(),
    getQualityCheckById(),
    getDownloadQualityChecks(),
    deleteQualityCheck(),
    getQualityCheckReport(),
    retestQualityCheck(),
    putQualityCheckOnHold(),
    updateQualityCheckAssignees(),
  ]);
}
